<template>
  <div class="image-box" :style="{ 'background-image': `url(${ getImage() })` }">

    <router-link v-if="item.link" :to="item.link" class="cover-link"></router-link>

    <div class="text d-flex flex-column align-items-start">
      <h5 class="text-white font-weight-normal btn-lg btn btn-blue-ml drop-rounded mx-auto" :class="{ h4: item.isVideo }" v-if="item.title">{{ item.title }}</h5>
    </div>

    <play-circle-icon class="text-white icon" v-if="item.isVideo" />
    <!-- <img :src="require(`@/assets/images/${item.thumb}`)"> -->
  </div>
</template>

<script>
  import PlayCircleIcon from "vue-material-design-icons/PlayCircle.vue"

  export default {
    name: 'ImageBox',

    props: {
      item: Object
    },

    methods: {
      getImage(){
        return require(`@/assets/images/${this.item.thumb}`)
      }
    },

    components: {
      PlayCircleIcon
    }
  }
</script>

<style lang="scss" scoped>
  .image-box{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;

    .cover-link{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0; 
      top: 0;
      z-index: 3;
    }

    .text{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 1.5rem;
      z-index: 2;    
    }

    .icon{
      position: absolute;
      z-index: 2;
      font-size: 4rem;
    }

    img{
      object-fit: cover;
      min-width: 100%;
      min-height: 100%;
      transition: transform .2s ease-in-out;
    }

    &:hover{
      img{
        transform: scale(1.05);
      }
    }
  }
</style>